var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInspectorSlice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 15v1H3v-1h1zm-2 0v1a1 1 0 01-1-1h1zm4 0v1H5v-1h1zm10 0a1 1 0 01-1 1v-1h1zm-8.566 0l-.176.194a.999.999 0 00-.249.807L7 16v-1h.434zM14 15v1h-1v-.67c.253-.164.503-.337.752-.52l-.267.19H14zM2 13v1H1v-1h1zm14 0v1h-1l.002-.205a18.23 18.23 0 00.837-.795H16zM2 11v1H1v-1h1zm0-2v1H1V9h1zm0-2v1H1V7h1zm14-2v1h-1V5h1zM2 5v1H1V5h1zm14-2v1h-1V3h1zM2 3v1H1V3h1zm2-2v1H3V1h1zM2 1v1H1a1 1 0 011-1zm4 0v1H5V1h1zm2 0v1H7V1h1zm2 0v1H9V1h1zm2 0v1h-1V1h1zm2 0v1h-1V1h1zm1 0a1 1 0 011 1h-1V1z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.33 12.084s-1.954 2.16-4.398 3.24C8.49 16.406 8 15.866 8 15.866l5.13-5.67 2.69-2.974a.647.647 0 01.976.002c.272.3.271.781.002 1.079l-2.445 2.702.977 1.08z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspectorSlice);
export default __webpack_public_path__ + "static/media/inspector-slice.a5805a9c.svg";
export { ForwardRef as ReactComponent };